 import { Ability, AbilityBuilder } from '@casl/ability'

export const ability = new Ability()

export const abilityPlugin = (store) => {
    
    var ab = AbilityBuilder.define(can => {       
        if(store.state.account.permissions != null)                                                              
        {
            store.state.account.permissions.forEach(elem => {                
                can('do',elem)
            })                            
        }
    })                
    ability.update(ab.rules)      

    return store.subscribe((mutation) => {
        
        switch (mutation.type) {
            case 'account/refreshPermissions':
                var ab = AbilityBuilder.define(can => {  
                    if(typeof(mutation.payload) !== 'undefined' && mutation.payload != null)                   
                    {
                        mutation.payload.forEach(elem => {
                            
                            can('do',elem)
                        })        
                    }
                })                
                ability.update(ab.rules)                       
                store.commit('account/abilityRefreshed')
                break
            case 'account/logout':
                ability.update([])
                store.commit('account/abilityRefreshed')
                break
        }
    })
}
